'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _adbar = require('redux/modules/adbar');

var adbarActions = _interopRequireWildcard(_adbar);

var _reactCookie = require('react-cookie');

var _storage = require('helpers/storage');

var _storage2 = _interopRequireDefault(_storage);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./AdBar.scss');
var googleBtnImg = require('./google-button-small.png');
var appleBtnImg = require('./apple-button-small.png');

var hideOnTime = 24 * 60 * 60 * 1000; // msec, hide ad time


var AdBar = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    hidden: state.adbar.adBarHidden
  };
}, (0, _extends3.default)({}, adbarActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (0, _reactCookie.withCookies)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(AdBar, _Component);

  function AdBar(props) {
    (0, _classCallCheck3.default)(this, AdBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdBar.__proto__ || (0, _getPrototypeOf2.default)(AdBar)).call(this, props));

    _this.cookies = new _storage2.default(props.cookies);
    return _this;
  }

  (0, _createClass3.default)(AdBar, [{
    key: 'hide',
    value: function hide() {
      var _this2 = this;

      var hideAd = this.props.hideAd;

      var now = Date.now();
      setTimeout(function () {
        _this2.cookies.set({ name: adbarActions.cookieNames.adBar, value: now, expires: new Date(now + hideOnTime) });
      }, 500);
      hideAd();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          hidden = _props.hidden;

      var adBarHideTime = this.cookies.get({ name: adbarActions.cookieNames.adBar }) || 0;

      if (adBarHideTime) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.adBar, (0, _defineProperty3.default)({}, styles.hidden, hidden)) },
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'span',
            null,
            t('For music on the go, download our app')
          ),
          _react2.default.createElement(
            'span',
            { className: 'nowrap' },
            _react2.default.createElement(
              'a',
              { className: styles.button, href: _config2.default.app.storeUrls.ios, target: '_blank' },
              _react2.default.createElement('img', { src: appleBtnImg, alt: '' })
            ),
            _react2.default.createElement(
              'a',
              { className: styles.button, href: _config2.default.app.storeUrls.android, target: '_blank' },
              _react2.default.createElement('img', { src: googleBtnImg, alt: '' })
            )
          )
        ),
        _react2.default.createElement(
          'button',
          { className: (0, _classnames2.default)('btn btn-clear', styles.closer), onClick: this.hide },
          _react2.default.createElement('i', { className: 'icon icon-close' })
        )
      );
    }
  }]);
  return AdBar;
}(_react.Component), _class3.propTypes = {
  cookies: _propTypes2.default.object,
  hidden: _propTypes2.default.bool,
  hideAd: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hide'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = AdBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AdBar/AdBar.js
// module id = 1940
// module chunks = 1